import {
  build_document_drawer_impl,
  build_dynamic_drawer_impl,
  build_flagged_drawer_impl,
  build_incident_drawer_impl,
  build_renewal_drawer_impl
} from './supplier_register_drawer_builders';

export const supplier_category_options = ['Technology', 'Construction', 'Professional services', 'Financial services', 'Logistics', 'Facilities'];
export const supplier_status_options = ['Active', 'Revalidation', 'Suspended', 'Onboarding'];
export const revalidation_reason_options = ['Documents expired (tax / BBBEE / insurance)', 'Incident triggered review', 'Risk threshold exceeded', 'Annual refresh due', 'Compliance requested full re-check'];

export function risk_tone_from_score(score) {
  if (score >= 70) {
    const high_tone = { label: `High - ${score}`, class: 'bg-danger-subtle text-danger-emphasis', drawer_tone: 'high' };
    return high_tone;
  }
  if (score >= 40) {
    const medium_tone = { label: `Medium - ${score}`, class: 'bg-warning-subtle text-warning-emphasis', drawer_tone: 'medium' };
    return medium_tone;
  }
  const low_tone = { label: `Low - ${score}`, class: 'bg-success-subtle text-success-emphasis', drawer_tone: 'low' };
  return low_tone;
}

export function status_meta_from_label(label) {
  if (label === 'Suspended') {
    const suspended_meta = { class: 'bg-danger-subtle text-danger-emphasis', drawer_tone: 'danger', payments: { label: 'Blocked', class: 'bg-danger-subtle text-danger-emphasis' }, payment_note: 'On hold' };
    return suspended_meta;
  }
  if (label === 'Revalidation') {
    const revalidation_meta = { class: 'bg-warning-subtle text-warning-emphasis', drawer_tone: 'medium', payments: { label: 'Clear', class: 'bg-success-subtle text-success-emphasis' }, payment_note: 'Released' };
    return revalidation_meta;
  }
  if (label === 'Onboarding') {
    const onboarding_meta = { class: 'bg-info-subtle text-info-emphasis', drawer_tone: 'medium', payments: { label: 'Pending', class: 'bg-light text-secondary' }, payment_note: 'Setup' };
    return onboarding_meta;
  }
  const active_meta = { class: 'bg-success-subtle text-success-emphasis', drawer_tone: 'success', payments: { label: 'Clear', class: 'bg-success-subtle text-success-emphasis' }, payment_note: 'Released' };
  return active_meta;
}

export function slugify_supplier(value) {
  return value.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
}

function normalise_control(value) {
  return value && value !== 'â€”' ? value : 'â€”';
}

export function build_dynamic_drawer(row, form = {}) {
  const dynamic_drawer = build_dynamic_drawer_impl(row, form, {
    normalise_control,
    risk_tone_from_score,
    status_meta_from_label
  });
  return dynamic_drawer;
}

export function build_document_drawer(document_row, supplier_row, supplier_drawer) {
  const document_drawer = build_document_drawer_impl(document_row, supplier_row, supplier_drawer);
  return document_drawer;
}

export function build_renewal_drawer(renewal_row, supplier_row, supplier_drawer) {
  const renewal_drawer = build_renewal_drawer_impl(renewal_row, supplier_row, supplier_drawer);
  return renewal_drawer;
}

export function build_incident_drawer(incident_row, supplier_row, supplier_drawer) {
  const incident_drawer = build_incident_drawer_impl(incident_row, supplier_row, supplier_drawer);
  return incident_drawer;
}

export function build_flagged_drawer(flagged_row, supplier_row, supplier_drawer) {
  const flagged_drawer = build_flagged_drawer_impl(flagged_row, supplier_row, supplier_drawer);
  return flagged_drawer;
}
